import React from 'react';
import { List as SpareItemsList } from '../../spares/spare-items';
import { List as SpareForwardingStatusesList } from '../../spares/spare-forwarding-statuses';
import {
  ReferenceCategoryWorkspace,
  type ReferenceNavItem,
} from './ReferenceCategoryWorkspace';

const BASE = '/parameters/spares-catalog';

const ITEMS: ReferenceNavItem[] = [
  {
    id: 'items',
    label: 'Items',
    description: 'Spare parts catalog',
    fillHeight: true,
    permissionModuleKey: 'spare_items',
  },
  {
    id: 'forwarding-statuses',
    label: 'Forwarding statuses',
    description: 'Spare case forwarding states',
    permissionModuleKey: 'spare_forwarding_statuses',
  },
];

function renderPanel(section: string) {
  switch (section) {
    case 'items':
      return <SpareItemsList />;
    case 'forwarding-statuses':
      return <SpareForwardingStatusesList />;
    default:
      return null;
  }
}

const SparesCatalogWorkspace: React.FC = () => (
  <ReferenceCategoryWorkspace
    basePath={BASE}
    eyebrow="Spares"
    items={ITEMS}
    defaultSection="items"
    renderPanel={renderPanel}
  />
);

export default SparesCatalogWorkspace;
